import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck } from '@fortawesome/free-solid-svg-icons';
import Modal from '../Modal';
import YetToBeImplemented from '../YetToBeImplemented/YetToBeImplemented';
import './CStudentComments.css';
import './CEdit.css';

function CStudentComments() {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <div className="CSCOM" onClick={() => setIsOpen(true)}>
        <div className="CSCOM_A3">
          <FontAwesomeIcon icon={faCircleCheck} />
        </div>
        <div className="CSCOM_A2">
          Student Comments
        </div>
      </div>
      <Modal isOpen={isOpen} setIsOpen={setIsOpen}>
        <div> <YetToBeImplemented /> </div>
      </Modal>
    </div>
  );
}

export default CStudentComments;
